// Utility to intercept clicks that should show early adopter modal
export const createEarlyAdopterHandler = (openModal: (source?: string) => void, source?: string) => {
  return (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    openModal(source || window.location.pathname + ' - button click');
  };
};

// URLs that should be intercepted
export const interceptedRoutes = [
  '/login',
  '/signup', 
  '/register',
  '/pricing',
  '/get-started',
  '/trial',
  '/plans'
];

// Check if a URL should be intercepted
export const shouldInterceptRoute = (url: string): boolean => {
  return interceptedRoutes.some(route => url.includes(route));
};